import * as React from "react";

const HTTP_VERB_COLORS = {
	"": "grey",
	get: "green",
	post: "#00aeff",
	patch: "purple",
	put: "orange",
	delete: "red",
};

interface HttpVerbProps {
	verb: string;
}

const HttpVerb = (props: HttpVerbProps) => (
	<div
		style={{
			display: "inline-block",
			color: HTTP_VERB_COLORS[props.verb.toLowerCase()] || HTTP_VERB_COLORS[""],
		}}
	>
		{props.verb}
	</div>
);

export default HttpVerb;



// WEBPACK FOOTER //
// ./src/components/HttpVerb.tsx